import api from './api';
import type { User, UserRole } from '../types';

export interface AuthResponse {
  token: string;
  user: User;
}

export const authService = {
  loginWithAzureAD: async (code: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/azure', { code });
    return response.data;
  },

  bypassLogin: async (email: string, role: UserRole): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/bypass', {
      email,
      role,
    });
    return response.data;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },
};
